

import moment from "moment";
import React, { Component } from "react";
import { yearOptions } from "../../../config";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import {tableConfig, transformChartData} from './config'
import CardBiaxialChart from "../../../../../../cards/BiaxialChart";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import {saveAs} from 'file-saver'
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";

//  type = 'service' | 'unit_entri'

export default class LaporanUnitL3Y extends Component {
  constructor(props) {
    super(props);
    this.currentYear = Number(moment().format("YYYY"));
    this.state = {
      year: yearOptions.find((item) => item.value === this.currentYear),
      dataTable: [],
      chartVisibility: false,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.kodeCabang?.value !== prevProps?.kodeCabang?.value) {
      this.handleSearch();
    }
  }

  handleChangeValue = (name, value) => {
    this.setState((prevValue) => ({ ...prevValue, [name]: value }));
  };

  fetchData = async () => {
    const { type } = this.props;
    if (type === "unit_entri") {
      return this.fetchUnitEntriL3Y();
    }
    return this.fetchDataUnitService();
  };

  fetchDataUnitService = async () => {
    const { setError, onTriggerLoading, kodeCabang } = this.props;
    const { year } = this.state;
    const userId = localStorage.getItem("userId");

    onTriggerLoading();
    if (!kodeCabang?.value) return;

    const res = await fetchDataAsync({
      asyncFn:
        Api.create("NAGAMAS_REPORT_DTO").getLaporanLast3YearUnitServiceH23,
      setError: setError,
      menuName:
        "Dashboard Level Kabeng Keatas - Tab Laporan Unit Servis 3 Tahun Terakhir",
      args: {
        kodeCabang: kodeCabang?.value,
        year: year?.value,
        idUser: userId,
        type: "MECHANIC",
      },
    });

    onTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataTable: res.data.data,
      });
    }
  };

  fetchUnitEntriL3Y = async () => {
    const { setError, onTriggerLoading, kodeCabang } = this.props;
    const { year } = this.state;
    if (!kodeCabang?.value) return;

    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn:
        Api.create("NAGAMAS_REPORT_DTO").getLaporanUnitEntryLastThreeYearH23,
      setError: setError,
      menuName:
        "Dashboard Level Kabeng Keatas - Laporan Unit Entri 3 Tahun Terakhir",
      args: {
        year: year?.value,
        kodeCabang: [kodeCabang?.value],
        employeeIdMechanic: null,
      },
    });

    onTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataTable: res.data.data,
      });
    }
  };

  handleChartVisibility = () => {
    this.setState((prev) => ({
      ...prev,
      chartVisibility: !prev.chartVisibility,
    }));
  };

  renderContent() {
    const { dataTable, chartVisibility } = this.state;

    if (chartVisibility) {
      const { data, dataKey } = transformChartData(dataTable);
      return <CardBiaxialChart data={data} dataKey={dataKey} />;
    }

    return (
      <SimpleDataTable
        data={dataTable}
        columns={tableConfig}
        options={{ pagination: false }}
      />
    );
  }

  handleSearch = () => {
    this.fetchData();
    this.setState({
      chartVisibility: false,
    });
  };
  handlePrint = async () => {
      const { onTriggerLoading, type, setError } = this.props;
      const { dataTable } = this.state;
  
      const title =
        type === "service"
          ? "Laporan Unit Servis 3 Tahun Terakhir"
          : type === "unit_entri"
            ? "Laporan Unit Entri 3 Tahun Terakhir"
            : " ";
  
      const fileName = title.split(" ").join("_");
  
      const reqBody = {
        filename: fileName,
        sheets: [
          {
            name: title,
            headers: tableConfig.map((item) =>
              item.name === "mechanicName" ? "Tim Mekanik" : item.label,
            ),
            data: dataTable.map((item) => ({
              "Tim Mekanik": item.mechanicName,
              "Q1 Y-2": item.q1y2,
              "Q2 Y-2": item.q2y2,
              "Q3 Y-2": item.q3y2,
              "Q4 Y-2": item.q4y2,
              "Q1 Y-1": item.q1y1,
              "Q2 Y-1": item.q2y1,
              "Q3 Y-1": item.q3y1,
              "Q4 Y-1": item.q4y1,
              "Q1 Y": item.q1y,
              "Q2 Y": item.q2y,
              "Q3 Y": item.q3y,
              "Q4 Y": item.q4y,
            })),
          },
        ],
      };
      onTriggerLoading();
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
        setError: setError,
        menuName: "Dashboard Kabeng Keatas - Laporan Unit 3 Tahun Terakhir",
        args: reqBody,
      });
  
      onTriggerLoading();
      if (res.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, fileName + ".xlsx");
      }
    };

  render() {
    const { year } = this.state;
    return (
      <React.Fragment>
        <FlexView className="margin-top-15px" style={{ gap: "20px" }}>
          <SimpleDDL
            id="select_options_tahun"
            box="search"
            name="year"
            containerclassname="width width-150px"
            placeholder="Tahun"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) => this.handleChangeValue(name, value)}
          />
          <SimpleButton
            id="btn_search"
            text="Cari"
            className="margin margin-top-5px"
            onClick={() => this.handleSearch()}
          />
        </FlexView>
        {this.renderContent()}
        <FlexView
          hAlignContent="right"
          className="margin-top-20px"
          style={{ gap: "20px" }}
        >
          <SimpleButton
            id="btn_print"
            text="CETAK"
            onClick={() => this.handlePrint()}
          />
          <SimpleButton
            id="btn_chart"
            text="CHART"
            onClick={() => this.handleChartVisibility()}
          />
        </FlexView>
      </React.Fragment>
    );
  }
}
